import { ENDPOINTS } from "utils/endpoints"
import { http } from "utils/http"


export const getOrganizationArchive = (id: any,showActiveRowsOnly=true) => http({
    url: ENDPOINTS.archive.organizationalArchive.Tree,
    method: "get",
    params: {
        ParentId: id,
        getActiveRowsOnly:showActiveRowsOnly

    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err.response  );
});



